import React from "react";
import { GameForm } from "../../components/forms/GameForm";

export const CreateGameBox = () => {
  return (
    <div>
      <GameForm />
    </div>
  );
};
